var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-tags"},[_c('div',{staticClass:"vx-icon filter",class:{ merch: _vm.isMerchActive, design: _vm.isDesignActive },attrs:{"id":"search-filter"},on:{"click":_vm.toggleFilters}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-filter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"line"})])
}]

export { render, staticRenderFns }